import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useParams, useNavigate, generatePath } from "react-router-dom";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import useGetClientId from "../../hooks/useGetClientId";
import http from "../../api/server";
import {
  GET_PROPERTIES_AND_INSPECTORS_BY_CLIENT,
  SCHEDULE_INSPECTION,
  GET_ALL_INSPECTION_MASTER,
  GET_INSPECTOR_AVAILABLE_SLOTS,
  GET_USERS_ROLE_BY_CLIENT_ID,
  GET_SCHEDULED_DATA,
  GET_RESCHEDULED_SLOTS,
  RE_SCHEDULE_INSPECTION,
} from "../../api/apiPath";
import useGetCity from "../../hooks/useGetCity";

import AvailableInspectorTile from "./AvailableInspectorTile";
import EndTimePopUp from "./EndTimePopUp";
import LoadingComponent from "../common/LoadingComponent";

import { Button } from "react-bootstrap";
import Select from "react-select";
// import Toaster from "../common/Toaster";
import { Calendar } from "react-multi-date-picker";
import { DateObject } from "react-multi-date-picker";
import { UserRoles } from "../common/constant";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Europe/London");
// import DatePicker from "react-multi-date-picker";

// import { sampleInspectorRows } from "../common/constant";
const FORMDATA = {
  propertyName: "",
  inspectionType: "",
  propertyId: "",
  cityId: 0,
};

const ScheduleMini = (props) => {
    const { inspectionMasterId, setToastData } = props;
  const { userObj } = useSelector((state) => state.user);
  const { clientNameParam } = useParams();
  const cityObj = useGetCity();
  const [formData, setFormData] = useState({
    ...FORMDATA,
    inspectionType: "Fire Door Survey",
  });
  const [selectedInspectors, setSelectedInpsectors] = useState([]);
  const [selectedApprovers, setSelectedApprovers] = useState([]);

  const [inspectorSlots, setInspectorSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState({});
  const [showEndPopUp, setShowEndPopUp] = useState(false);
  const [showConfirmPopUp, setShowConfirmPopUp] = useState(false);
  const [errors, setErrors] = useState({
    approvers: "",
    dateRange: "",
    inspector: "",
  });
  const [cityOptions, setCityOptions] = useState([]);
  const [inspectorOptions, setInspectorOptions] = useState([]);
  const [approverOptions, setApproverOptions] = useState([]);
  const [cityInspectorOptions, setCityInspectorOptions] = useState([]);
  const [cityApproverOptions, setCityApproverOptions] = useState([]);

  const [otherCityInspectors, setOtherCityInspectors] = useState([]);
  const [dateRange, setDateRange] = useState([new DateObject()]);
  const [dateInputValue, setDateInputValue] = useState("");
  const [source, setSource] = useState("calendar"); // or "input"
  const [propertyInspectors, setPropertyInspectors] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isReschedule, setIsReschedule] = useState(false);
  const [bookingExists, setBookingExists] = useState(false);
  const [allUserRoles, setAllUserRoles] = useState([]);
  const [submitDisabled, setSubmitDisabled] = useState(
    Object.values(formData).some(
      (value) => value === "" || value === null || value === undefined,
    ) || selectedInspectors.length === 0,
  );
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const today = dayjs().tz("Europe/London");

  const navigate = useNavigate();

  const clientObj = useGetClientId();

  // const [toastData, setToastData] = useState({
  //   toastShow: false,
  //   toastType: "",
  //   toastString: "",
  // });
  // const closeButton = () => {
  //   setToastData({
  //     toastShow: false,
  //     toastData: "",
  //     toastType: "",
  //   });
  // };

  useEffect(() => {
    if (clientObj.clientId && userObj) {
      handleGetAllPropertyByClinetID(clientObj.clientId);
    }
  }, [clientObj.clientId, clientObj.loading]);

  useEffect(() => {
    setCityOptions(cityObj?.cityList);
  }, [cityObj.cityList, cityObj.loading]);

  const handleGetAllPropertyByClinetID = async (clientId) => {
    try {
      const response = await http.get(
        GET_PROPERTIES_AND_INSPECTORS_BY_CLIENT +
          "?ClientId=" +
          clientId +
          "&loggedinUserEmail=" +
          userObj?.userEmail,
      );
      if (response.status === 200) {
        console.log("response.data", response?.data);
        // setPropertyOptions(response?.data?.properties);
        const inspectorOptions = response?.data?.inspectors.map((i) => ({
          value: i.inspectorId,
          label: i.inspectorName,
          cityId: i.cityId,
        }));
        setInspectorOptions(inspectorOptions);
        setPropertyInspectors(response?.data?.propertyInspectors);

        const approverList = await getUsersRoleByClientId(clientObj.clientId);

        if (inspectionMasterId) {
          await setEditInspectionData(inspectorOptions, approverList);
        }
      }
    } catch (error) {
      return error;
    } finally {
      // setLoading(false);
    }
  };

  const getScheduledData = async (inspectorsList) => {
    try {
      const response = await http.post(
        GET_SCHEDULED_DATA + "?InspectionAssignmentId=" + inspectionMasterId,
      );
      if (response?.status === 200) {
        if (
          Array.isArray(response?.data?.data) &&
          response?.data?.data.length > 0
        ) {
          setIsReschedule(true);
          setBookingExists(true);
          const tempSlots = {};
          const dateranges = [];

          inspectorsList.forEach((insp) => {
            let scheduleData = response?.data?.data.filter(
              (x) => x.inspectorId === insp.value,
            )[0];

            // Fallback: try to match by inspector name if inspectorId doesn't match
            if (!scheduleData) {
              scheduleData = response?.data?.data.find(
                (x) =>
                  x.bookedInspectorEmail &&
                  (x.bookedInspectorEmail
                    .toLowerCase()
                    .includes(insp.label.toLowerCase()) ||
                    insp.label
                      .toLowerCase()
                      .includes(
                        x.bookedInspectorEmail.split("@")[0].toLowerCase(),
                      )),
              );
            }

            if (!scheduleData) {
              return;
            }

            const start = scheduleData?.startTime;
            const end = scheduleData?.endTime;
            dateranges.push(start);
            dateranges.push(end);

            const result = setToMidnight(start);

            const newobj = {
              date: result,
              endTime: end,
              inspectorEmail: scheduleData?.bookedInspectorEmail,
              inspectorName: insp.label,
              isCurrentBooking: false,
              slotId: `${scheduleData?.bookedInspectorEmail}-${result}-${start}`,
              startTime: start,
            };
            tempSlots[scheduleData?.bookedInspectorEmail] = newobj;
          });

          if (dateranges.length === 0) {
            setIsReschedule(false);
            setBookingExists(false);
            return;
          }

          // Convert to Date objects and sort
          const sorted = dateranges
            .map((d) => new Date(d))
            .sort((a, b) => a - b);

          // Format as ISO without milliseconds
          const startMidnight = setToMidnight(sorted[0].toISOString());
          const endMidnight = setToMidnight(
            sorted[sorted.length - 1].toISOString(),
          );
          //setDateRange([new Date(startMidnight), new Date(endMidnight)]);
          //setDateInputValue(formatRange([startMidnight, endMidnight]));
          const forRange = `${startMidnight.split("T")[0]} to ${
            endMidnight.split("T")[0]
          }`;
          setDateInputValue(forRange);

          setSelectedSlot(tempSlots);
        } else {
          setIsReschedule(false);
          setBookingExists(false);
        }
      }
    } catch (error) {
      return error;
    } finally {
      setLoading(false);
    }
  };

  //  const stripTime = (date) => {
  //   const d = new Date(date);
  //   d.setHours(0, 0, 0, 0);
  //   return d;
  // };
  const setToMidnight = (date) => {
    const newdate = date.split("T")[0]; // "2025-10-12"
    return `${newdate}T00:00:00`;
  };

  const setEditInspectionData = async (inspectorList, approverList) => {
    try {
      const response = await http.get(
        GET_ALL_INSPECTION_MASTER + "?ClientId=" + clientObj?.clientId,
      );
      console.log(response);
      if (response?.status === 200) {
        const editData = response?.data?.filter(
          (x) => x.inspectionMasterId == inspectionMasterId,
        );
        if (editData.length > 0) {
          setFormData({
            ...formData,
            propertyName: editData[0].properties[0]?.propertyName,
            propertyId: editData[0].properties[0]?.propertyMasterId,
            inspectionType: editData[0].inspectionType,
            cityId: editData[0].properties[0]?.cityId,
            approvalDueDate: editData[0]?.approvalDueDate,
            duplicateInspection: editData[0]?.isDuplicate || false,
          });

          const preinsp = editData[0].assignedInspectors?.map((i) => ({
            value: i.inspectorId,
            label: i.inspectorName,
          }));
          setSelectedInpsectors(preinsp);
          const cityOptionsnew = getCityInspectorOptions(
            preinsp,
            editData[0].properties[0]?.cityId,
            inspectorList,
          );
          setCityInspectorOptions(cityOptionsnew);
          setOtherCityInspectors(editData[0].inspectorsByCity);
          const preappr = editData[0].assignedApprovers?.map((i) => ({
            value: i.aproverId,
            label: i.approverName,
            cityId: i.cityId,
          }));
          setSelectedApprovers(preappr);
          const cityOptionApprsnew = getCityInspectorOptions(
            preappr,
            editData[0].properties[0]?.cityId,
            approverList,
          );
          setCityApproverOptions(cityOptionApprsnew);
          getScheduledData(preinsp);
        }
      }
    } catch (error) {
      console.log(error);
      setError(error);
    }
  };

  const getCityInspectorOptions = (preinsp, cityId, newinspectorOptions) => {
    console.log(approverOptions);
    const normalizeOption = (o) => ({
      value: o?.value ?? o?.inspectorId,
      label: o?.label ?? o?.inspectorName ?? "Unnamed",
      cityId: o?.cityId ?? o?.cityid, // accept both keys
    });
    const inspOpt = newinspectorOptions
      ? newinspectorOptions
      : inspectorOptions;
    const cityOptions = inspOpt
      .map(normalizeOption)
      .filter((ins) => Number(ins.cityId) === Number(cityId));

    const merged = [
      ...cityOptions.map(normalizeOption),
      ...preinsp.map(normalizeOption),
    ];

    const cityOptionsnew = Array.from(
      new Map(merged.map((o) => [String(o.value), o])).values(),
    );

    return cityOptionsnew;
  };

  const getUsersRoleByClientId = async (clientId) => {
    try {
      const response = await http.get(
        GET_USERS_ROLE_BY_CLIENT_ID + "?clientId=" + clientId,
      );
      if (response.status === 200) {
        // Filter roles
        const approvers = response?.data?.filter(
          (item) => item.roleName === "Approver",
        );

        // Dropdown options
        const approverlist = approvers.map((a) => ({
          value: a.userId,
          label: a.fullName,
          cityId: a.cityId,
        }));
        setAllUserRoles(response?.data);
        setApproverOptions(approverlist);
        return approverlist;
      }
    } catch (error) {
      return error;
    }
  };

  // const formatDateString = (dateString) => {
  //   const dateObj = new Date(dateString);
  //   if (!isNaN(dateObj)) {
  //     const year = dateObj.getFullYear();
  //     const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  //     const day = String(dateObj.getDate()).padStart(2, "0");
  //     return `${year}-${month}-${day}`;
  //   }
  //   return "";
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedFormData = formData;

    if (name === "propertyName") {
      let preinsp = [];
      const selectedInsp = propertyInspectors.filter(
        (x) => x.propertyMasterId === value,
      );
      console.log("sele", selectedInsp);
      if (value !== "" && selectedInsp.length !== 0) {
        updatedFormData = {
          ...formData,
          [name]: value,
          //   preDefinedInspector: selectedInsp[0].inspectorId,
        };
        preinsp = selectedInsp.map((i) => ({
          value: i.inspectorId,
          label: i.inspectorName,
        }));
      } else {
        updatedFormData = {
          ...formData,
          [name]: value,
          //   preDefinedInspector: "",
        };
        preinsp = [];
      }
      setSelectedInpsectors(preinsp);
    } else {
      updatedFormData = { ...formData, [name]: value };
    }

    handleDisableSave(updatedFormData, selectedInspectors);
    setFormData(updatedFormData);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value ? "" : prevErrors[name],
    }));
  };

  const handleDisableSave = (data, inspector) => {
    console.log(submitDisabled);
    setSubmitDisabled(
      Object.values(data).some(
        (value) => value === "" || value === null || value === undefined,
      ) || inspector.length === 0,
    );
  };

  const approverRef = useRef(null);
  const validate = () => {
    const newErrors = {};
    if (selectedApprovers.length === 0)
      newErrors.approvers = "Approver is required";
    if (selectedInspectors.length === 0)
      newErrors.inspector = "Inspector is required";
    if (!dateInputValue) newErrors.dateRange = "Date Range is required";
    return newErrors;
  };

  const validateInspector = () => {
    const newErrors = {};
    if (selectedInspectors.length === 0)
      newErrors.inspector = "Inspector is required";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setShowConfirmPopUp(false);
      approverRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      approverRef.current.focus();
    } else {
      console.log("Form submitting...", formData, selectedSlot, cityOptions);
      setShowConfirmPopUp(false);
      setIsSubmitting(true);
      // const inspectorArray = selectedInspectors?.map((u) => u.value.toString());
      const inspectorArr = [];
      Object.entries(selectedSlot).map(([email, slot]) => {
        const inspectorid = inspectorSlots.filter(
          (x) => x.inspectorEmail === email,
        )[0];
        const isSelectedInspector =
          selectedInspectors.filter(
            (x) => x.label === inspectorid.inspectorName,
          ).length > 0;
        const newObj = {
          inspectorUserId: isSelectedInspector
            ? selectedInspectors.filter(
                (x) => x.label === inspectorid.inspectorName,
              )[0].value
            : otherCityInspectors.filter(
                (x) => x.inspectorName === inspectorid.inspectorName,
              )[0].inspectorId,
          inspectorType:
            allUserRoles.filter(
              (x) =>
                x.userEmail === inspectorid.inspectorEmail &&
                x.roleId === UserRoles.INSPECTOR,
            )[0].userType || "String",
          slots: [
            {
              startTime: dayjs
                .tz(slot.startTime, "Europe/London")
                .utc()
                .format("YYYY-MM-DDTHH:mm:ss"),
              endTime: dayjs
                .tz(slot.endTime, "Europe/London")
                .utc()
                .format("YYYY-MM-DDTHH:mm:ss"),
            },
          ],
          isFullDayBooking: slot.isFullDay,
          assignmentId: inspectionMasterId,
        };
        inspectorArr.push(newObj);
      });
      const approverArr = [];
      selectedApprovers.map((appr) => {
        const newObj = {
          aproverId: appr.value,
          approverName: appr.label,
          cityId: appr.cityId,
        };
        approverArr.push(newObj);
      });
      try {
        const payload = isReschedule
          ? {
              propertyMasterId: formData.propertyId,
              clientId: clientObj?.clientId,
              inspectors: inspectorArr,
              loggedInUserEmail: userObj?.userEmail,
              assignmentId: inspectionMasterId ? inspectionMasterId : 0,
              assignedApproversUserIds: selectedApprovers?.map((v) =>
                v.value.toString(),
              ),
              isDuplicateInspection: formData.duplicateInspection ? formData.duplicateInspection : false,
            }
          : {
              propertyMasterId: formData.propertyId,
              clientId: clientObj?.clientId,
              inspectors: inspectorArr,
              approvers: approverArr,
              loggedInUserEmail: userObj?.userEmail,
              assignmentId: inspectionMasterId ? inspectionMasterId : 0,
              isDuplicateInspection: formData.duplicateInspection ? formData.duplicateInspection : false,
            };
        console.log("pay", payload);

        await submitFormData(JSON.stringify(payload));
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  // const submitFormData = async (payload) => {
  //   try {
  //     const endpoint = isReschedule
  //       ? RE_SCHEDULE_INSPECTION
  //       : SCHEDULE_INSPECTION;
  //     const response = await http.post(endpoint, payload);
  //     if (response?.status === 200) {
  //       setTimeout(() => {
  //         setToastData({
  //           toastShow: true,
  //           toastType: "success",
  //           toastString: response?.data?.message,
  //         });
  //       }, 1000);
  //       // handleCancel();
  //         setTimeout(() => {
  //            handleCancel();
  //          }, 6000);
  //       console.log(response);
  //     } else {
  //       setTimeout(() => {
  //         setToastData({
  //           toastShow: true,
  //           toastType: "failure",
  //           toastString: "Error in saving data, please try again.",
  //         });
  //       }, 1000);
  //     }
  //   } catch (error) {
  //     console.error("Error submitting form:", error.data?.message);

  //     const mgs =
  //       error?.data?.message?? "Error due to conflicts, please try again";

  //     setToastData({
  //       toastShow: true,
  //       toastType: "failure",
  //       toastString: mgs,
  //     });
  //   }
  // };

  const submitFormData = async (payload) => {
    try {
      const endpoint = isReschedule
        ? RE_SCHEDULE_INSPECTION
        : SCHEDULE_INSPECTION;

      const response = await http.post(endpoint, payload);

      if (response?.status === 200) {
        const resData = response?.data;

        const successList = resData?.data?.success || resData?.success || [];

        const conflictList =
          resData?.data?.conflicts || resData?.conflicts || [];

        let messages = [];

        if (resData?.message) {
          messages.push(resData.message);
        }

        successList.forEach((item) => {
          if (item?.message) {
            messages.push(item.message);
          }
        });

        conflictList.forEach((item) => {
          if (item?.message) {
            messages.push(item.message);
          }
        });

        const finalMessage = messages.join("\n");

        let toastType = "success";

        if (successList.length > 0 && conflictList.length > 0) {
          toastType = "warning";
        } else if (successList.length === 0 && conflictList.length > 0) {
          toastType = "failure";
        }

        setToastData({
          toastShow: true,
          toastType: toastType,
          toastString: finalMessage,
        });

        if (successList.length > 0) {
          setTimeout(() => {
            handleCancel();
          }, 2000);
        }

        // console.log(response);
      } else {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: "Error in saving data, please try again.",
        });
      }
    } catch (error) {
      const msg =
        error?.data?.conflicts?.[0]?.message ||
        error?.response?.data?.message ||
        "Error due to conflicts, please try again";

      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: msg,
      });
    }
  };

  const handleCancel = () => {
    navigate(
      generatePath("/client/:clientNameParam/inspectionDashboard", {
        clientNameParam,
      }),
    );
  };

  useEffect(() => {
    if (source === "calendar") {
      setDateInputValue(formatRange(dateRange));
      setErrors({
        ...errors,
        dateRange: "",
      });
    }
  }, [dateRange, source]);

  // Format for input field
  const formatRange = (range) => {
    const [start, end] = range;
    const format = (d) => d?.format?.("YYYY-MM-DD") || "";
    return start && end ? `${format(start)} to ${format(end)}` : "";
  };
  const handleInputChange = (e) => {
    const value = e.target.value;
    setDateInputValue(value); // Let user type freely
    setSource("input"); //prevent useeffect overwrite

    if (value === "") {
      setDateRange([new DateObject()]);
      setErrors({
        ...errors,
        dateRange: "",
      });
      setInspectorSlots([]);
      if (!bookingExists) {
        setSelectedSlot({});
      }
      return;
    }

    const inspectorValidation = validateInspector();
    if (Object.keys(inspectorValidation).length > 0) {
      setErrors(inspectorValidation);
      setInspectorSlots([]);
      if (!bookingExists) {
        setSelectedSlot({});
      }
      return;
    }

    const [startStr, endStr] = value.split(" to ");
    const isValidFormat = (str) => /^\d{4}-\d{2}-\d{2}$/.test(str);

    if (!isValidFormat(startStr) || !isValidFormat(endStr)) {
      setErrors({
        ...errors,
        dateRange: "Invalid format. Use YYYY-MM-DD to YYYY-MM-DD",
      });
      setInspectorSlots([]);
      if (!bookingExists) {
        setSelectedSlot({});
      }
      return;
    }
    if (startStr && endStr) {
      const start = new DateObject({ date: startStr, format: "YYYY-MM-DD" });
      const end = new DateObject({ date: endStr, format: "YYYY-MM-DD" });
      if (start.toDate() > end.toDate()) {
        setErrors({
          ...errors,
          dateRange: "Start date must be before end date",
        });
        setInspectorSlots([]);
        if (!bookingExists) {
          setSelectedSlot({});
        }
        return;
      }
      const approvalDate =  formData.approvalDueDate?.split("T")[0];
      const approvalDateObj = new DateObject({date: approvalDate, format: "YYYY-MM-DD"});
      if(end.toDate() > approvalDateObj.toDate()){
        setErrors({
          ...errors,
          dateRange: `End date must not exceed Approval Target Date given : ${new Date(formData.approvalDueDate).toLocaleDateString("en-US")}`,
        });
        setInspectorSlots([]);
        if (!bookingExists) {
          setSelectedSlot({});
        }
        return;
      }
      setDateRange([new Date(start), new Date(end)]);
      setErrors({
        ...errors,
        dateRange: "",
      });
      if (!bookingExists) {
        setSelectedSlot({});
      }
      setInspectorSlots([]);
      isReschedule
        ? getInspectorRescheduleSlots([start, end])
        : getInspectorSlots([start, end]);
    }
  };

  const handleCalendarChange = (newRange) => {
    setSource("calendar");
    setDateRange(newRange);
    const inspectorValidation = validateInspector();
    if (Object.keys(inspectorValidation).length > 0) {
      setErrors(inspectorValidation);
      setInspectorSlots([]);
      if (!bookingExists) {
        setSelectedSlot({});
      }
      return;
    }
    if (!bookingExists) {
      setSelectedSlot({});
    }
    setInspectorSlots([]);
    isReschedule
      ? getInspectorRescheduleSlots(newRange)
      : getInspectorSlots(newRange);
  };

  const handleDateAlreadySelected = (e) => {
    if (e.length === 0) {
      if (!bookingExists) {
        setSelectedSlot({});
      }
      setInspectorSlots([]);
      return;
    }
    if (!dateInputValue) {
      if (!bookingExists) {
        setSelectedSlot({});
      }
      setInspectorSlots([]);
      return;
    }
    const [start, end] = dateRange;
    if (start && end) {
      isReschedule
        ? getInspectorRescheduleSlots([start, end], e)
        : getInspectorSlots([start, end], e);
    }
  };

  const getInspectorSlots = async (range, newInspectors) => {
    const [start, end] = range;
    const startDateStr =
      dayjs(start)?.tz("Europe/London").format("YYYY-MM-DD") || "";
    const endDateStr =
      dayjs(end)?.tz("Europe/London").format("YYYY-MM-DD") || "";
    const inspectionIds = newInspectors
      ? newInspectors.map((x) => x.value)
      : selectedInspectors.map((x) => x.value);
    const params = new URLSearchParams();
    params.append("StartDate", startDateStr);
    params.append("EndDate", endDateStr);
    inspectionIds.forEach((id) => params.append("InspectorUserIds", id));
    params.append("ClientId", clientObj.clientId);
    params.append("InspectionAssignmentId", inspectionMasterId);

    const queryString = params.toString();
    if (startDateStr && endDateStr) {
      try {
        const response = await http.get(
          GET_INSPECTOR_AVAILABLE_SLOTS + `?${queryString}`,
        );
        if (response.status === 200) {
          console.log(response?.data);

          let tempInspectorSlots = [];
          const inspectorList = newInspectors
            ? newInspectors
            : selectedInspectors;
          inspectorList.map((inspector) => {
            const arr1 = response?.data.filter(
              (x) => x.inspectorFullName === inspector.label,
            );
            const flatmapped = arr1.flatMap((item) => item.availability);
            console.log("flat", flatmapped);
            const formattedSlots = flatmapped.map((item) => {
              const ukDate = dayjs.tz(item.date, "Europe/London");
              const formatSlots = item.slots.map((slot) => {
                const ukTimeS = dayjs.tz(slot.startTime, "Europe/London");
                const ukTimeE = dayjs.tz(slot.endTime, "Europe/London");
                return {
                  isCurrentBooking: slot.isCurrentBooking,
                  startTime: ukTimeS.format("YYYY-MM-DDTHH:mm:ss"),
                  endTime: ukTimeE.format("YYYY-MM-DDTHH:mm:ss"),
                  ukTimeObj: ukTimeS,
                };
              });
              const now = dayjs();
              const futureSlots = formatSlots.filter((slot) =>
                slot.ukTimeObj.isAfter(now),
              );
              return {
                date: ukDate.format("YYYY-MM-DDTHH:mm:ss"),
                slots: futureSlots,
              };
            });

            const newObj = {
              inspectorName: arr1[0].inspectorFullName,
              inspectorEmail: arr1[0].inspectorEmail,
              inspectorSlots: formattedSlots,
            };
            const anyFilled = newObj.inspectorSlots.some(
              (entry) => Array.isArray(entry.slots) && entry.slots.length > 0,
            ); //Returns true if at least one slots array has content.
            newObj.availability = anyFilled;
            tempInspectorSlots.push(newObj);
          });
          console.log("slots", tempInspectorSlots);

          setInspectorSlots(tempInspectorSlots);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const getInspectorRescheduleSlots = async (range, newInspectors) => {
    const [start, end] = range;
    const startDateStr =
      dayjs(start)?.tz("Europe/London").format("YYYY-MM-DD") || "";
    const endDateStr =
      dayjs(end)?.tz("Europe/London").format("YYYY-MM-DD") || "";
    const inspectionIds = newInspectors
      ? newInspectors.map((x) => x.value)
      : selectedInspectors.map((x) => x.value);
    const params = new URLSearchParams();
    params.append("StartDate", startDateStr);
    params.append("EndDate", endDateStr);
    inspectionIds.forEach((id) => params.append("InspectorUserIds", id));
    params.append("ClientId", clientObj.clientId);
    params.append("InspectionAssignmentId", inspectionMasterId);

    const queryString = params.toString();
    if (startDateStr && endDateStr && inspectionIds) {
      try {
        const response = await http.post(
          GET_RESCHEDULED_SLOTS + `?${queryString}`,
        );
        if (response.status === 200) {
          console.log(response?.data?.data);
          const rescheduleSlots = response?.data?.data?.availableSlots;

          let tempInspectorSlots = [];
          const inspectorList = newInspectors
            ? newInspectors
            : selectedInspectors;
          inspectorList.map((inspector) => {
            const arr1 = rescheduleSlots?.filter(
              (x) => x.inspectorFullName === inspector.label,
            );
            const flatmapped = arr1.flatMap((item) => item.availability);
            console.log("flat", flatmapped);
            const formattedSlots = flatmapped.map((item) => {
              const ukDate = dayjs.tz(item.date, "Europe/London");
              const formatSlots = item.slots.map((slot) => {
                const ukTimeS = dayjs.tz(slot.startTime, "Europe/London");
                const ukTimeE = dayjs.tz(slot.endTime, "Europe/London");
                return {
                  isCurrentBooking: slot.isCurrentBooking,
                  startTime: ukTimeS.format("YYYY-MM-DDTHH:mm:ss"),
                  endTime: ukTimeE.format("YYYY-MM-DDTHH:mm:ss"),
                  ukTimeObj: ukTimeS,
                };
              });
              const now = dayjs();
              const futureSlots = formatSlots.filter((slot) =>
                slot.ukTimeObj.isAfter(now),
              );
              return {
                date: ukDate.format("YYYY-MM-DDTHH:mm:ss"),
                slots: futureSlots,
              };
            });
            const newObj = {
              inspectorName: arr1[0]?.inspectorFullName,
              inspectorEmail: arr1[0]?.inspectorEmail,
              inspectorSlots: formattedSlots,
            };
            const anyFilled = newObj.inspectorSlots.some(
              (entry) => Array.isArray(entry.slots) && entry.slots.length > 0,
            ); //Returns true if at least one slots array has content.
            newObj.availability = anyFilled;
            tempInspectorSlots.push(newObj);
          });
          console.log("slots", tempInspectorSlots);

          setInspectorSlots(tempInspectorSlots);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleOtherAvailableInspectors = async () => {
    if (otherCityInspectors && otherCityInspectors.length === 0) {
      return;
    }
    const [start, end] = dateRange;
    const startDateStr = start?.format?.("YYYY-MM-DD") || "";
    const endDateStr = end?.format?.("YYYY-MM-DD") || "";
    console.log("other", otherCityInspectors);
    const inspectionIds = otherCityInspectors.map((x) => x.inspectorId);
    const params = new URLSearchParams();
    params.append("StartDate", startDateStr);
    params.append("EndDate", endDateStr);
    inspectionIds.forEach((id) => params.append("InspectorUserIds", id));
    params.append("ClientId", clientObj.clientId);

    const queryString = params.toString();
    if (startDateStr && endDateStr) {
      try {
        const response = await http.get(
          GET_INSPECTOR_AVAILABLE_SLOTS + `?${queryString}`,
        );
        if (response.status === 200) {
          console.log(response?.data);

          let tempInspectorSlots = [];
          otherCityInspectors.map((inspector) => {
            const arr1 = response?.data.filter(
              (x) => x.inspectorFullName === inspector.inspectorName,
            );
            const newObj = {
              inspectorName: arr1[0].inspectorFullName,
              inspectorEmail: arr1[0].inspectorEmail,
              inspectorSlots: arr1.flatMap((item) => item.availability),
            };
            const anyFilled = newObj.inspectorSlots.some(
              (entry) => Array.isArray(entry.slots) && entry.slots.length > 0,
            ); //Returns true if at least one slots array has content.
            newObj.availability = anyFilled;
            tempInspectorSlots.push(newObj);
          });
          console.log("slots", tempInspectorSlots);
          const newSlots = [...inspectorSlots, ...tempInspectorSlots];

          setInspectorSlots(newSlots);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleEndTimeChange = (email, updatedSlot) => {
    setSelectedSlot((prev) => ({
      ...prev,
      [email]: {
        ...prev[email],
        ...updatedSlot, // or just endTime: updatedSlot if you're passing only the new value
      },
    }));
  };

  const handleReset = () => {
    setDateRange([new DateObject()]);
    setSelectedSlot({});
    setInspectorSlots([]);
    if (!isReschedule) {
      setSelectedApprovers([]);
    }
    setDateInputValue("");
  };

  if (error)
    return (
      <>
        <div className="inCenterDiv">
          <i className="bi bi-exclamation-triangle red"></i>
          <h3>Something went wrong!</h3>
          <p>{error?.message}</p>
          <div className="col-sm-12 mb-4 text-center">
            <Link
              to={generatePath("/client/:clientNameParam/", {
                clientNameParam,
              })}
            >
              Go back to Login
            </Link>
          </div>
        </div>
      </>
    );

  return (
    <>
      {/* <Toaster
        show={toastData.toastShow}
        toastType={toastData.toastType}
        title={toastData.toastString}
        theme={"dark"}
        position="top-center"
        closeButton={closeButton}
      /> */}
      {userObj && (

          <div className="d-flex flex-column py-1 w-100">
            <div className="p-2 border-0 w-100">
              <div className="dashboard_header">
                <h2 className="mb-0">Schedule Inspection</h2>
                <p className="header-description">
                  Schedule inspection for this property
                </p>
              </div>
              <div className="schedule-grid">
                <div className="resident-card d-flex justify-content-center">
                  <Calendar
                    value={dateRange}
                    onChange={handleCalendarChange}
                    range
                    disabled={bookingExists}
                    zIndex={0}
                    rangeHover
                    layout={"prime"}
                    showOtherDays
                    shadow={false}
                    minDate={today.toDate()}
                    maxDate={new Date(formData.approvalDueDate)}
                    highlightToday={false}
                    // format="MM-DD-YYYY"
                    headerOrder={["MONTH_YEAR", "LEFT_BUTTON", "RIGHT_BUTTON"]}
                  />
                </div>
                <div>
                  <p>Additional Information</p>
                  <div className="resident-card px-2 pt-3 pb-4 mb-4">
                    <div className="card-body-section px-3">
                      <div className="form-group">
                        <label htmlFor="approvalDueDate">
                          Location <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          className="form-control"
                          placeholder="City"
                          id="approvalDueDate"
                          type="Text"
                          disabled
                          name="approvalDueDate"
                          value={
                            cityOptions?.filter(
                              (x) => x.cityId === formData.cityId,
                            )[0]?.cityName
                          }
                          onChange={handleChange}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="approvalDueDate">
                          Date Range <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          className={
                            errors.dateRange
                              ? "input-error form-control"
                              : "form-control"
                          }
                          placeholder="YYYY-MM-DD to YYYY-MM-DD"
                          id="approvalDueDate"
                          type="Text"
                          name="approvalDueDate"
                          value={dateInputValue}
                          disabled={bookingExists}
                          onChange={handleInputChange}
                        />

                        {/* <DatePicker
                          selectsRange
                          startDate={
                            dateRange[0] ? new Date(dateRange[0]) : null
                          }
                          endDate={dateRange[1] ? new Date(dateRange[1]) : null}
                          onChange={(dates) => {
                            const [start, end] = dates;

                            if (!start || !end) return;

                            const startStr = start.toISOString().split("T")[0];
                            const endStr = end.toISOString().split("T")[0];

                            const value = `${startStr} to ${endStr}`;

                            // 🔥 SAME FLOW AS INPUT
                            handleInputChange({
                              target: {
                                value,
                              },
                            });
                          }}
                          placeholderText="YYYY-MM-DD to YYYY-MM-DD"
                          disabled={bookingExists}
                          minDate={today.toDate()}
                          dateFormat="MM-dd-yyyy"
                          className={
                            errors.dateRange
                              ? "input-error form-control"
                              : "form-control"
                          }
                        /> */}
                        {errors.dateRange && (
                          <span className="formError mt-0">
                            {errors.dateRange}
                          </span>
                        )}
                      </div>
                      <div className="form-group">
                        <label htmlFor="floatingEmail">
                          Assigned Inspector(s){" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          isMulti
                          isDisabled={bookingExists}
                          options={cityInspectorOptions}
                          value={selectedInspectors}
                          className={errors.inspector ? "input-error" : ""}
                          onChange={(e) => {
                            console.log("insp", selectedInspectors, e);
                            setSelectedInpsectors(e);
                            handleDateAlreadySelected(e);
                            handleDisableSave(formData, e);
                            setErrors({
                              ...errors,
                              inspector: "",
                            });
                          }}
                          name="preDefinedInspector"
                          isClearable={false}
                          menuPortalTarget={document.body}
                          styles={{
                            container: (base) => ({
                              ...base,
                              width: "100%",
                              height: "2.81rem",
                            }),
                            control: (base) => ({
                              ...base,
                              minHeight: "2.81rem",
                            }),
                            placeholder: (base) => ({
                              ...base,
                              textAlign: "left",
                              marginLeft: "1rem",
                              color: "#a3a3a3",
                              opacity: 0.8,
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                        />
                        {errors.inspector && (
                          <span className="formError mt-0">
                            {errors.inspector}
                          </span>
                        )}
                      </div>
                      <div className="form-group">
                        <label htmlFor="floatingEmail" ref={approverRef}>
                          Approver(s) <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          isMulti
                          isDisabled={bookingExists}
                          placeholder="Select Approver"
                          options={cityApproverOptions}
                          value={selectedApprovers}
                          className={errors.approvers ? "input-error" : ""}
                          onChange={(e) => {
                            console.log("insp", selectedApprovers, e);
                            setSelectedApprovers(e);
                            handleDisableSave(formData, e);
                            setErrors({
                              ...errors,
                              approvers: "",
                            });
                          }}
                          name="preDefinedInspector"
                          isClearable={false}
                          menuPortalTarget={document.body}
                          styles={{
                            container: (base) => ({
                              ...base,
                              width: "100%",
                              height: "2.81rem",
                            }),
                            control: (base) => ({
                              ...base,
                              minHeight: "2.81rem",
                            }),
                            placeholder: (base) => ({
                              ...base,
                              textAlign: "left",
                              marginLeft: "1rem",
                              color: "#a3a3a3",
                              opacity: 0.8,
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                        />
                        {errors.approvers && (
                          <span className="formError mt-0">
                            {errors.approvers}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {bookingExists && (
                <div className="schedule-inspectors">
                  <p>Booking Details</p>
                </div>
              )}
              {bookingExists &&
                selectedSlot &&
                typeof selectedSlot === "object" &&
                Object.entries(selectedSlot)?.map(([email, slot]) => {
                  const startTimeFormatted = `${dayjs
                    .tz(slot.startTime, "Europe/London")
                    .format("ddd, MMM D - h:mm A")}`;
                  const selectedEndTime = `${dayjs
                    .tz(slot.endTime, "Europe/London")
                    .format("ddd, MMM D - h:mm A")}`;

                  // const endTimeOptions = getEndTimeOptions(email, slot);
                  // console.log("eee", endTimeOptions, selectedEndTime);
                  return (
                    <div
                      key={email}
                      className="resident-card w-100 py-3 px-3 mb-2 d-flex flex-column align-items-start"
                    >
                      <p className="endtime-label pb-1">Inspector</p>
                      <p className="endtime-value pb-2">{slot.inspectorName}</p>
                      <p className="endtime-label pb-1">Start Time</p>
                      <p className="endtime-value pb-2">{startTimeFormatted}</p>
                      <p className="endtime-label pb-1">End Time</p>
                      <p className="endtime-value pb-2">{selectedEndTime}</p>
                    </div>
                  );
                })}
              {inspectorSlots && inspectorSlots.length > 0 && (
                <div className="schedule-inspectors">
                  <p>Available Inspectors</p>
                  <div className="resident-card mb-4">
                    <AvailableInspectorTile
                      assignedInspectorList={inspectorSlots}
                      selectedSlot={selectedSlot}
                      setSelectedSlot={setSelectedSlot}
                      onShowOtherInspectors={handleOtherAvailableInspectors}
                      otherCityInspectors={otherCityInspectors}
                    />
                  </div>
                </div>
              )}

              {!bookingExists && (
                <div className="pb-3 button-group">
                  <Button
                    type="reset"
                    className="col-12 col-sm-12 col-lg-2 col-md-3"
                    size="md"
                    variant="tertiary"
                    onClick={handleCancel}
                    disabled={isSubmitting}
                    style={{ fontWeight: "600" }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="reset"
                    className="col-12 col-sm-12 col-lg-2 col-md-3"
                    size="md"
                    variant="secondary"
                    disabled={isSubmitting}
                    onClick={handleReset}
                    style={{ fontWeight: "600" }}
                  >
                    Reset
                  </Button>
                  <Button
                    variant="primary"
                    size="sm"
                    className="col-12 col-sm-12 col-lg-2 col-md-3"
                    active
                    type="submit"
                    onClick={() => setShowEndPopUp(true)}
                    style={{ fontWeight: "600" }}
                    disabled={
                      isSubmitting || Object.keys(selectedSlot).length === 0
                    }
                    // disabled
                  >
                    {isSubmitting
                      ? "Scheduling..."
                      : isReschedule
                        ? "Re-Schedule Inspection"
                        : "Schedule Inspection"}
                  </Button>
                </div>
              )}
              {bookingExists && (
                <div className="pb-3 button-group">
                  <Button
                    type="reset"
                    className="col-12 col-sm-12 col-lg-2 col-md-3"
                    size="md"
                    variant="secondary"
                    onClick={handleCancel}
                    disabled={isSubmitting}
                    style={{ fontWeight: "600" }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    size="sm"
                    className="col-12 col-sm-12 col-lg-2 col-md-3"
                    active
                    type="submit"
                    onClick={() => {
                      setBookingExists(false);
                      handleReset();
                    }}
                    style={{ fontWeight: "600" }}
                    disabled={
                      isSubmitting || Object.keys(selectedSlot).length === 0
                    }
                  >
                    Re-Schedule Inspection
                  </Button>
                </div>
              )}
            </div>
            {showEndPopUp && (
              <EndTimePopUp
                assignedInspectorList={inspectorSlots}
                selectedSlot={selectedSlot}
                onEndTimeChange={handleEndTimeChange}
                onCancel={() => setShowEndPopUp(false)}
                onSubmit={() => {
                  setShowEndPopUp(false);
                  setShowConfirmPopUp(true);
                }}
                isReadOnly={false}
              />
            )}
            {showConfirmPopUp && (
              <EndTimePopUp
                assignedInspectorList={inspectorSlots}
                selectedSlot={selectedSlot}
                onEndTimeChange={handleEndTimeChange}
                onCancel={() => setShowConfirmPopUp(false)}
                onSubmit={(e) => handleSubmit(e)}
                isReadOnly={true}
              />
            )}
            <LoadingComponent loading={loading} />
          </div>

      )}
    </>
  );
};

export default ScheduleMini;
